import { Request } from 'commons/utils/request'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { ExportCSVButton } from 'ui/temp/ExportCSVButton'

import { useEmailHistoryReportContext } from '../../context/EmailHistoryReportContext'

export const PageActions = () => {
  const { state } = useEmailHistoryReportContext()
  return (
    <ButtonGroup margin="small">
      <ExportCSVButton
        reportName="Email History"
        url={Request.urls.bank.portalReportEmailHistoryCSV}
        parametersForm={state}
        method="put"
      />
    </ButtonGroup>
  )
}
